/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Model } from '@app/shared/models/model.model';
import { Contact } from '@app/shared/components/contact/contact.model';
import { ContactPerson } from '@app/shared/components/contact-person/contact-person.model';
import { BankAccount } from '@app/shared/components/bank-accounts/bank-account.model';
import { City } from '@app/settings/cities/cities.model';
import { VenueDistance } from '@app/shared/components/venue-distance/venue-distance.model';
import { Type } from '@app/settings/types/types.model';
import { HotelsSeo } from '@app/hotels/hotels/hotels-seo.model';
import { Facility } from '@app/settings/facilities/facilities.model';

// @todo: тоя модел трябва да се погледне
export class Hotel extends Model {
  id: number;
  name: string;
  address: string;
  stars: number;
  distance_to_center: number;
  distance_to_airport: number;
  distance_to_tr_point: number;
  distance_to_tr_point_name: string;
  rooms_count: number;
  contacts: Array<Contact>;
  contact_persons: Array<ContactPerson>;
  bank_accounts: Array<BankAccount>;
  lat: number;
  long: number;
  type_id: number;
  type: Type;
  city_id: number;
  city?: City;
  active: boolean;
  show_to_web: boolean;
  venues: Array<VenueDistance>;
  venue?: VenueDistance;
  translations?: Array<HotelsSeo>;
  facilities: Array<Facility>;
  note: string;
  links?: Array<any>;
  gallery?: any;
  gallery_count?: number;
  vat_number: string;

  deserialize(input: any): this {
    super.deserialize(input);

    if (input.type) {
      this.type = new Type().deserialize(input.type);
    }

    return this;
  }

  get activeContactPersons(): Array<ContactPerson> {
    return this.contact_persons.filter((cp: ContactPerson) => {
      return cp.show;
    });
  }
}
